import { useEffect } from "react";
import { useNavigate } from "react-router";

interface PopStateParams {
	title: string;
	path: string;
	dispatchActions?: () => void;
}

const useHandlePopState = ({ title, path, dispatchActions = () => {} }: PopStateParams) => {
	const navigate = useNavigate();

	useEffect(() => {
		window.onpopstate = () => {
			window.history.replaceState(null, title, path);
			window.onpopstate = () => {};
			dispatchActions?.();
			navigate(path, { replace: true });
		};
	}, [title, path, dispatchActions, navigate]);
};

export default useHandlePopState;
